<template lang="pug">
#modelTree.comAll(v-dragDiv, v-show="!actionData.isMini")
  .title.moveDragDiv
    span {{ actionData.cnName }}
    i.el-icon-minus.minibtn(title="最小化", @click="miniCom")
    i.el-icon-close(title="关闭", @click="closeAdd")
  .content
    el-tree.navTree(ref="tree", node-key="mgNodeId", :props="defaultProps", :load="loadNode", lazy, v-slot="{ node, data }")
      .tree-node
        template(v-if="data.isBtn")
          .more-button(@click.stop="addMore(node)", :title="data.moreText") 显示更多
        template(v-else)
          el-checkbox(
            :indeterminate="indeterminateMap[data.mgNodeId]",
            @click.native.capture.stop,
            :value="checkKeysList",
            :label="data.mgNodeId",
            @input="keysCheckChange($event, node)"
          )
            span
          .label(@click.stop="handleClick(data)", :title="data.label") {{ data.label }}
  .bottomRow()
    el-checkbox(v-model="checkAll" :indeterminate="indeterminate") 全选
    el-checkbox(v-model="checkInvert" @change="invertBatch") 反选
</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import { mongeApp } from "@/CommonDP/mongeView/store/mongeStore";
const map = new WeakMap();
export default {
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      checkInvert: false,
      treeData: [],
      checkKeysList: [],
      indeterminateMap: {},
      nodeMap: {},
      defaultProps: {
        children: "children",
        label: "label",
        isLeaf: (n) => n.isLeaf
      },
      allMgNodeIds: [], // 所有节点id
    };
  },
  computed: {
    checked_arr() {
      return mongeApp.model.showElementIdlist;
    },
    hiddenElementIdList() {
      return mongeApp.model.hiddenElementIdList;
    },
    // 全选
    checkAll: {
      get(){
        let ids = this.allMgNodeIds || [];
        if(!ids.length) return false;
        let exist = ids.some(id => {
          return !this.checkKeysList.includes(id);
        });
        return !exist;
      },
      set(val){
        this.checkInvert = false; // 重置反选
        let list = [];
        if(val) list = this.allMgNodeIds.filter(id => !this.checkKeysList.includes(id));
        else list = [...this.checkKeysList];
        this.changeCheckNodes(list, val);
      }
    },
    // 半全选
    indeterminate() {
      let ids = this.allMgNodeIds || [];
      let exist = ids.some(id => {
        return this.checkKeysList.includes(id);
      });
      let isIndeterminate = Object.values(this.indeterminateMap)?.includes(true);
      return (!this.checkAll && exist) || isIndeterminate;
    },
  },
  mounted() {
    this.checkKeysList = [];
  },
  methods: {
    // 获得所有节点id
    getAllNodes(){
      if(!this.$refs.tree) return [];
      const allNodes = this.$refs.tree.store?._getAllNodes() || []; // 获取所有节点数据
      let list = [];
      allNodes.forEach(node => {
        let data = node?.data || {};
        if(data?.mgNodeId) list.push(data.mgNodeId);
      });
      return list;
    },
    // 批量改变选中状态
    changeCheckNodes(list, check){
      if(check) {
        list.forEach(id => {
          let exist = this.checkKeysList.includes(id);
          let node = this.$refs.tree?.getNode(id);
          if(!exist && node) {
            this.checkKeysList.push(id);
            this.keysCheckChange(this.checkKeysList, node);
          }   
        });
      } else {
        list.forEach(id => {
          let exist = this.checkKeysList.includes(id);
          let node = this.$refs.tree?.getNode(id);
          if(exist && node) {
            this.checkKeysList = this.checkKeysList.filter(item => item !== id);
            this.keysCheckChange(this.checkKeysList, node);
          }   
        });
      }
    },
    // 反选
    invertBatch(){
      let list = this.allMgNodeIds.filter(id => !this.checkKeysList.includes(id));
      let closeList = [...this.checkKeysList];
      this.changeCheckNodes(closeList, false);
      this.changeCheckNodes(list, true);
    },
    isIndeterminate(node) {
      return this.checkKeysList.find((e) => e.mgNodeId === node.data.mgNodeId).type === -1;
    },
    addMore(node) {
      node.data.isBtn = false;
      this.lazyLoadTreeLevel(node.parent);
      this.$nextTick(()=>{
        this.allMgNodeIds = this.getAllNodes();
      });
    },
    lazyLoadTreeLevel(node) {
      if (this._isDestroyed) return;
      const source = map.get(node);
      if (!source.length) return;
      const step = 20;
      const children = node.childNodes || [];
      const start = children.length;
      const end = start + step;
      const plus = source.slice(start, end);
      const addNext = end < source.length;
      if (addNext) {
        const plusLast = plus[step - 1];
        plusLast.isBtn = true;
        plusLast.moreText = `共${source.length}条,已加载${end - 1}条`;
      } else {
        map.delete(node);
      }
      node.doCreateChildren(plus);
    },
    async loadNode(node, resolve) {
      const list = mongeApiMlib.loadTreeData(node) || [];
      for (const e of list) {
        const type = mongeApiMlib.elementIsHide(e.modelId, e.elementId);
        if (type === 0) {
          this.$nextTick(()=>{
            this.checkKeysList.push(e.mgNodeId);
          });
        } else if (type === -1) {
          this.$set(this.indeterminateMap, e.mgNodeId, true);
        }
      }
      resolve([]);
      map.set(node, list);
      this.lazyLoadTreeLevel(node);
      this.$nextTick(()=>{
        this.allMgNodeIds = this.getAllNodes();
      });
    },
    keysCheckChange(val, node) {
      const idSet = new Set(val);
      const {
        data: { modelId, elementId, mgNodeId }
      } = node;
      const boolean = idSet.has(mgNodeId);
      this.$set(this.indeterminateMap, mgNodeId, false);
      if (boolean) {
        mongeApiMlib.elementIdShow(modelId, elementId);
      } else {
        mongeApiMlib.elementIdHide(modelId, elementId);
      }
      // 向下处理节点
      const clist = [...node.childNodes];
      for (const cnode of clist) {
        const cid = cnode.data.mgNodeId;
        boolean ? idSet.add(cid) : idSet.delete(cid);
        clist.push(...cnode.childNodes);
      }
      // 向上处理
      const plist = [node.parent];
      for (const pnode of plist) {
        const pid = pnode?.data?.mgNodeId;
        if (!pid) break;
        const childNodes = pnode.childNodes;
        const hasList = childNodes.filter((n) => idSet.has(n.data.mgNodeId));
        this.$set(this.indeterminateMap, pid, false);
        if (hasList.length === 0) {
          idSet.delete(pid);
        } else if (hasList.length === childNodes.length) {
          idSet.add(pid);
        } else {
          idSet.add(pid);
          this.$set(this.indeterminateMap, pid, true);
        }
        const ppnode = pnode.parent;
        if (ppnode) plist.push(ppnode);
      }
      this.checkKeysList = [...idSet];
    },
    async dealType(data, type) {
      if (type === 0) {
        mongeApiMlib.elementIdHide(data.modelId, data.elementId);
        return 1;
      } else if (type === 1) {
        mongeApiMlib.elementIdShow(data.modelId, data.elementId);
        return 0;
      } else if (type === -1) {
        mongeApiMlib.elementIdShow(data.modelId, data.elementId);
        return 0;
      }
    },
    miniCom() {
      this.$emit("closeCom", "modelTree", true);
    },
    closeAdd() {
      this.$emit("closeCom", "modelTree", false);
    },
    handleClick(data) {
      mongeApiMlib.selectPick(data);
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss"></style>
<style lang="scss" scoped>
$color: #4777e7;
.tree-node {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  .label {
    margin-left: 5px;
    width: calc(100% - 25px);
  }
}
#modelTree {
  position: fixed;
  top: 65px;
  left: 151px;
  width: 300px;
  height: calc(100% - 190px);
  max-height: 770px;
  .content {
    width: 100%;
    height: calc(100% - 40px - 35px);
    padding: 10px 10px 10px 15px;
    overflow: hidden;
    overflow-y: auto;
  }
  .bottomRow{
    width: 100%;
    padding: 8px 16px;
  }
}
.more-button {
  position: absolute;
  inset: 0;
  text-align: center;
  background-color: #fff;
  cursor: pointer;
  color: $color;
  &:hover {
    color: lighten($color, 15%);
  }
}
.navTree /deep/ {
  .el-tree-node > .el-tree-node__children > .el-tree-node {
    position: relative;
  }
}
</style>
